import Vue from 'vue';
import Vuex from 'vuex';
import user from './modules/user';
import advMoudel from './modules/advMoudel';
import getters from './getters';

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    user,
    advMoudel
  },
  getters
});

export default store;
